import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6363feb0")

_pushScopeId("data-v-6363feb0")
const _hoisted_1 = { class: "w-11/12" }
const _hoisted_2 = { class: "font-semibold text-14px label-accordion" }
const _hoisted_3 = {
  key: 0,
  class: 
        `w-full px-5 border-r border-l border-b rounded-b-lg border-gray-lp-400`
      
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args))),
      class: 
        `cursor-pointer text-black-lp-300 py-2 px-4 border ${_ctx.bgHead} flex flex-wrap flex-row items-center justify-between ${
          _ctx.modelAccordion ? 'rounded-t-lg ' : 'rounded-lg'
        } ${_ctx.borderHead} leading-tight font-normal`
      
    }, [
      _createVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
        ], {}, true)
      ]),
      _createVNode("img", {
        src: require(`@/app/ui/assets/svg/${_ctx.expandIcon}.svg`),
        class: "w-6 justify-self-end",
        alt: "expand"
      }, null, 8, ["src"])
    ], 2),
    (_ctx.modelAccordion)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_TableV2, {
            class: "w-full",
            columns: _ctx.columns,
            data: _ctx.dataList,
            loading: _ctx.isLoading,
            errorCause: _ctx.errorCause,
            pinnedSubstractHeight: "290px",
            borderTop: false,
            borderBottom: false,
            groupOptions: _ctx.actionGroupOptions,
            groupAction: "",
            iconName: "ellipsis",
            isShowPagination: false
          }, null, 8, ["columns", "data", "loading", "errorCause", "groupOptions"])
        ]))
      : _createCommentVNode("", true)
  ]))
})